<template>
	<div class="stamp-winnner">
		<ParticipantList ref="participantList" @initCheck="initCheck" />
		<WinnerList
			ref="winnerList"
			@initCheck="initCheck"
			@selectedWinnerLengthChange="selectedWinnerLengthChange"
		/>
		<ManagingSection size="l">
			<ManagingBox title="당첨자 공지 메세지">
				<TextCounter
					v-model="message"
					:maxLength="1000"
					:useTextarea="true"
				/>
				<div class="stamp-winnner__message-button-wrap">
					<button
						class="btn blue"
						v-text="'공지 메세지 저장'"
						@click="saveMessage"
					/>
				</div>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				:disabled="disabledfixWinnerButton"
				class="btn-main blue"
				v-text="'당첨자 공지(확정)'"
				@click="fixWinner"
			/>
			<router-link
				:is="!selectedWinnerLength ? 'span' : 'router-link'"
				:disabled="!selectedWinnerLength"
				:to="newPushPath"
				target="_blank"
				:class="['btn-main', { disabled: !selectedWinnerLength }]"
				>선택한 당첨자에게 당첨자공지 푸시발송</router-link
			>
		</div>
	</div>
</template>
<script>
	import sumBy from 'lodash/sumBy';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import Selector from '@/components/Selector.vue';
	import TextCounter from '@/components/TextCounter.vue';
	import ParticipantList from '@/components/stamp/ParticipantList.vue';
	import WinnerList from '@/components/stamp/WinnerList.vue';

	export default {
		name: 'EventStampWinner',
		components: {
			ManagingSection,
			ManagingBox,
			Selector,
			TextCounter,
			ParticipantList,
			WinnerList,
		},
		data() {
			return {
				id: this.$route.params.idStamp,
				message: '',
				selectedWinnerLength: 0,
			};
		},
		computed: {
			...mapState({
				details: state => state.stamp.details,
				conditionList: state => state.stamp.conditionList,
				participantList: state => state.stamp.participantList,
				targetGroup: state => state.stamp.targetGroup,
			}),
			...mapGetters({
				getWinnerCount: 'stamp/getWinnerCount',
			}),
			disabledfixWinnerButton() {
				return (
					this.details?.select_on ||
					this.getWinnerCount(null) !=
						sumBy(this.conditionList, 'sum_winner')
				);
			},
			newPushPath() {
				return {
					path: '/manage/push-send',
					query: {
						linkType: 'stamp_winner_id',
						linkValue: this.id,
						register_ids: this.selectedWinnerLength
							? (
									this.$refs.winnerList?.$refs.registerList
										?.checkListModel || []
								).join(',')
							: undefined,
					},
				};
			},
		},
		methods: {
			selectedWinnerLengthChange(length) {
				this.selectedWinnerLength = length;
			},
			async setDetails() {
				const message = await this.$store.dispatch(
					'stamp/setDetails',
					this.id
				);
				this.message = message;
			},
			initCheck(type) {
				if (type === 'participant' || !type)
					this.$refs.participantList.initCheck();
				if (type === 'winner' || !type)
					this.$refs.winnerList.initCheck();
			},
			async setWinnerList() {
				await this.$store.dispatch('stamp/setWinnerList');
				this.$emit('initCheck');
			},
			async saveMessage() {
				try {
					this.$store.commit('toggleSpinner', true);
					const params = { message: this.message, type: 'message' };
					await this.$axiosAdmin2NoSpinner.post(
						`/v3/api/stamp/${this.id}/winner`,
						params
					);
				} catch (e) {
					console.error(e);
					alert('공지 메세지 저장 실패!');
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			async fixWinner() {
				if (
					!this.details.select_on &&
					!confirm(
						'당첨자 공지후에는 이를 취소하거나 당첨자를 수정할 수 없습니다.\n당첨자 공지를 진행하려면 [확인] 버튼을 클릭해주세요.'
					)
				) {
					return;
				}
				try {
					this.$store.commit('toggleSpinner', true);
					const params = { type: 'winner' };
					await this.$axiosAdmin2NoSpinner.post(
						`/v3/api/stamp/${this.id}/winner`,
						params
					);
					await this.setDetails();
				} catch (e) {
					console.error(e);
					alert('당첨자 공지(확정) 실패!');
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
		},
		created() {
			this.$store.commit('stamp/init');
			this.$store.commit('stamp/changeState', [
				{ key: 'id', value: this.id },
			]);
		},
		async mounted() {
			this.$store.commit('toggleSpinner', true);
			await this.setDetails();
			await Promise.all([
				this.$refs.participantList.setParticipantList(),
				this.setWinnerList(),
				this.$store.dispatch('stamp/setTargetGroupWinnerList'),
			]);
			this.$store.commit('toggleSpinner', false);
		},
		destroyed() {
			this.$store.commit('stamp/init');
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-winnner {
		&__message-button-wrap {
			display: flex;
			justify-content: flex-end;
			width: 100%;
			margin-top: 12px;
		}
	}
</style>
